var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEcranprojection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.98 65.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#e6007e;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill:#e6007e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\xE9cran_de_projection",
    "data-name": "\\xE9cran de projection"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.8,14.61A29.8,29.8,0,0,0,1,33,32,32,0,0,0,55.61,55.61a32,32,0,0,0,0-45.24h0A31.79,31.79,0,0,0,33,1a29.47,29.47,0,0,0-17.9,5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.53,11.62a1.57,1.57,0,1,0-1.11-.46A1.57,1.57,0,0,0,10.53,11.62Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.49,49.52H54.43a.71.71,0,0,0,.72-.71V46a.72.72,0,0,0-.72-.72h-.71V22.36h.71a.71.71,0,0,0,.72-.71V18.79a.72.72,0,0,0-.72-.72H36.49a3.57,3.57,0,0,0-7,0H11.55a.72.72,0,0,0-.72.72v2.86a.71.71,0,0,0,.72.71h.71V45.23h-.71a.72.72,0,0,0-.72.72v2.86a.71.71,0,0,0,.72.71H29.49M33,16.64a2.15,2.15,0,0,1,2,1.43H31A2.17,2.17,0,0,1,33,16.64ZM12.26,19.5H53.72v1.43H12.26ZM31,49.52h4m18.72-1.43H12.26V46.66H53.72Zm-1.43-2.86H13.69V22.36h38.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33,42.37a8.58,8.58,0,1,0-8.58-8.57A8.58,8.58,0,0,0,33,42.37Zm0-15.72a7.15,7.15,0,1,1-7.15,7.15A7.15,7.15,0,0,1,33,26.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.52,38.72a.73.73,0,0,0,.33.08.71.71,0,0,0,.42-.14L37,34.37a.71.71,0,0,0,.14-1,.47.47,0,0,0-.14-.14l-5.72-4.29a.7.7,0,0,0-.75-.07.71.71,0,0,0-.39.64v8.58A.71.71,0,0,0,30.52,38.72Zm1-7.78,3.81,2.86-3.81,2.86Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcranprojection);
export default __webpack_public_path__ + "static/media/ecranprojection.9b827a73153e6fb3fe819865cca7daa4.svg";
export { ForwardRef as ReactComponent };